/**
 * Normalize Firestore / API timestamp values to epoch milliseconds.
 */

export function timestampToMs(v) {
  if (v == null) return null;
  if (typeof v.toMillis === 'function') return v.toMillis();
  if (typeof v.toDate === 'function') return v.toDate().getTime();
  if (v instanceof Date) return v.getTime();
  if (typeof v === 'string') {
    const t = Date.parse(v);
    return Number.isNaN(t) ? null : t;
  }
  if (typeof v === 'number' && Number.isFinite(v)) {
    return v > 1e12 ? v : v * 1000;
  }
  if (typeof v.seconds === 'number') {
    return v.seconds * 1000 + (v.nanoseconds || 0) / 1e6;
  }
  return null;
}
